import React from 'react';
import ClassAssembly  from 'views/ClassAssembly9D2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;